import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';

const StyBackButton = styled(Button, {
    name: 'StyBackButton',
})(({ theme }) => ({
    backgroundColor: theme.palette.red,
    color: 'white',
}));

type BackButtonProps = {
    defaultReturn: string;
    // This can be used to add behavior when the back button is clicked.
    // The navigation happens independently of either this prop is defined or not
    onClick?: () => void;
};

const BackButton = ({
    defaultReturn,
    onClick: onClickProp,
}: BackButtonProps): React.ReactElement => {
    const navigate = useNavigate();
    const { state: historyState } = useLocation();
    const { t } = useTranslation();

    const onClick = () => {
        if (onClickProp) onClickProp();
        navigate(historyState.parentLocation, { replace: true });
    };

    // Parent Location is an argument given from the previous page we come from and
    // where we want to go back when we hit the button return.
    // Default behavior is to return to a generic page given in arguments. It's useful for example if
    // the page is shared and the previous page location couldn't be passed
    return historyState && historyState.parentLocation ? (
        <StyBackButton onClick={onClick} variant="contained">
            {t('common.return')}
        </StyBackButton>
    ) : (
        <Link to={defaultReturn}>
            <StyBackButton variant="contained">
                {t('common.return')}
            </StyBackButton>
        </Link>
    );
};

export default BackButton;
